import HomeScreen from '@screens/home/HomeScreen'
import DraftsScreen from '@screens/drafts/DraftsScreen'
import LoginScreen from '@screens/login/LoginScreen'
import ResetPassword from '@screens/resetPassword/ResetPasswordScreen'

import LoginSsoCallbackScreen from '@screens/login/LoginSsoCallbackScreen'
import ManifestationsScreen from '@screens/manifestations/ManifestationsScreen'
import ManifestationsMonthScreen from '@screens/manifestations/ManifestationMonthScreen'
import ManifestationsDetailScreen from '@screens/manifestations/detail/ManifestationDetailScreen'
import TenantsScreen from '@screens/tenants/TenantsScreen'
import TenantDetailScreen from '@screens/tenants/detail/TenantDetailScreen'
import DocumentsScreen from '@screens/documents/DocumentsScreen'
import IncidentFormScreen from '@screens/incident/IncidentFormScreen'
import IncidentDetailScreen from '@screens/incident/detail/IncidentDetailScreen'
import ExpoIncidentDetailScreen from '@screens/incident/detail/ExpoIncidentDetailScreen'
import IncidentListScreen from '@screens/incident/IncidentListScreen'
import UnaffectedIncidentListScreen from '@screens/incident/UnaffectedIncidentListScreen'
import FilteredIncidentListScreen from '@screens/incident/FilteredIncidentListScreen'
import MapScreen from '@screens/incident/MapScreen'

import AccountScreen from '@screens/account/AccountScreen'
import AccountInfoScreen from '@screens/account/AccountInfoScreen'
import AccountNotificationScreen from '@screens/account/AccountNotificationScreen'
import AccountIdentificationScreen from '@screens/account/AccountIdentificationScreen'
import AccountLangScreen from '@screens/account/AccountLangScreen'
import AccountSignatureScreen from '@screens/account/AccountSignatureScreen'
import HelpScreen from '@screens/help/HelpScreen'

import EDLScreen from '@screens/edl/EDLScreen'
import EDLListScreen from '@screens/edl/list/EDLListScreen'
import EDLSpaceScreen from '@screens/edl/map/EDLSpaceScreen'
import EDLMapScreen from '@screens/edl/map/EDLMapScreen'
import EDLRecapScreen from '@screens/edl/recap/EDLRecapScreen'
import EDLSignatureScreen from '@screens/edl/signature/EDLSignatureScreen'

import ControleListScreen from '@screens/controle/ControleListScreen'
import ControleScreen from '@screens/controle/ControleScreen'
import ControleFormScreen from '@screens/controle/form/ControleFormScreen'
import ControleDetailScreen from '@screens/controle/ControleDetailScreen'
import ControleHistoryListScreen from '@screens/controle/ControleHistoryListScreen'
import ControleHistoryDetailScreen from '@screens/controle/ControleHistoryDetailScreen'

import UserListScreen from '@screens/admin/users/UserListScreen'
import AdminUserScreen from '@screens/admin/user/AdminUserScreen'
import AdminPrestaScreen from '@screens/admin/presta/AdminPrestaScreen'
import AdminOrgaListScreen from '@screens/admin/orga/AdminOrgaListScreen'
import AdminManifScreen from '@screens/admin/orga/AdminManifScreen'
import AdminServiceScreen from '@screens/admin/presta/AdminServiceScreen'
import AdminUserFormScreen from '@screens/admin/users/userForm/AdminUserFormScreen'
import AdminRoleListScreen from '@screens/admin/roles/AdminRoleListScreen'
import AdminRoleScreen from '@screens/admin/roles/AdminRoleScreen'
import AdminRoleFormScreen from '@screens/admin/roles/form/AdminRoleFormScreen'
import AdminJobsScreen from '@screens/admin/jobs/AdminJobsScreen'
import AdminPlanListScreen from '@screens/admin/plans/AdminPlanListScreen'
import AdminPlanScreen from '@screens/admin/plans/AdminPlanScreen'
import AdminPlanFormScreen from '@screens/admin/plans/form/AdminPlanFormScreen'

// Dev only
import StorybookScreen from '@screens/storybook/StorybookScreen'
import TodoScreen from '@screens/todo/TodoScreen'

import { AuthScope } from '@api/enum'

const screens: { [key in ScreenName]: ScreenDefinition } = {
  home: {
    name: 'home',
    icon: 'viparis',
    screen: HomeScreen as RootScreen,
    path: '/',
    auth: true,
  },
  drafts: {
    name: 'drafts',
    icon: 'viparis',
    screen: DraftsScreen as RootScreen,
    path: '/drafts',
    auth: true,
  },
  manifestations: {
    name: 'manifestations',
    icon: 'apartment',
    screen: ManifestationsScreen as RootScreen,
    path: '/manifestations',
    auth: true,
    scopes: [
      AuthScope.ManifestationsExposantLecture,
      AuthScope.ManifestationsLecture,
      AuthScope.ManifestationsTousLecture,
      AuthScope.ManifestationsUtilisateurLecture,
    ],
  },
  manifestationDetail: {
    name: 'manifestationDetail',
    icon: 'apartment',
    screen: ManifestationsDetailScreen as unknown as RootScreen,
    path: '/manifestation/:manifestationId',
    auth: true,
  },
  manifestationMonth: {
    name: 'manifestationMonth',
    icon: 'apartment',
    screen: ManifestationsMonthScreen as unknown as RootScreen,
    path: '/manifestationMonth',
    auth: true,
    scopes: [
      AuthScope.ManifestationsExposantLecture,
      AuthScope.ManifestationsLecture,
      AuthScope.ManifestationsTousLecture,
      AuthScope.ManifestationsUtilisateurLecture,
    ],
  },

  // account
  account: {
    name: 'account',
    icon: 'tab_profile',
    screen: AccountScreen as RootScreen,
    path: '/account',
    auth: true,
  },
  help: {
    name: 'help',
    icon: 'tab_profile',
    screen: HelpScreen as RootScreen,
    path: '/account/help',
    auth: true,
  },
  generalInformation: {
    name: 'generalInformation',
    icon: 'tab_profile',
    screen: AccountInfoScreen as RootScreen,
    path: '/account/info',
    auth: true,
  },
  notification: {
    name: 'notification',
    icon: 'tab_profile',
    screen: AccountNotificationScreen as RootScreen,
    path: '/account/notification',
    auth: true,
  },
  identification: {
    name: 'identification',
    icon: 'tab_profile',
    screen: AccountIdentificationScreen as RootScreen,
    path: '/account/identification',
    auth: true,
  },
  lang: {
    name: 'lang',
    icon: 'tab_profile',
    screen: AccountLangScreen as RootScreen,
    path: '/account/lang',
    auth: true,
  },
  signature: {
    name: 'signature',
    icon: 'tab_profile',
    screen: AccountSignatureScreen as RootScreen,
    path: '/account/signature',
    auth: true,
  },
  edlList: {
    name: 'edlList',
    icon: 'tab_edl',
    screen: EDLListScreen as RootScreen,
    path: '/edl',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  edl: {
    name: 'edl',
    icon: 'tab_edl',
    screen: EDLScreen as unknown as RootScreen,
    path: '/edl/detail/:id',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  edlSpace: {
    name: 'edlSpace',
    icon: 'tab_edl',
    screen: EDLSpaceScreen as unknown as RootScreen,
    path: '/edl/spaces/:id',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  edlMap: {
    name: 'edlMap',
    icon: 'tab_edl',
    screen: EDLMapScreen as unknown as RootScreen,
    path: '/edl/map/:id',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  edlRecap: {
    name: 'edlRecap',
    icon: 'tab_edl',
    screen: EDLRecapScreen as unknown as RootScreen,
    path: '/edl/recap/:id',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  edlSignature: {
    name: 'edlSignature',
    icon: 'tab_edl',
    screen: EDLSignatureScreen as unknown as RootScreen,
    path: '/edl/signature/:id',
    auth: true,
    scopes: [AuthScope.EdlSiteLecture],
  },
  checklist: {
    name: 'checklist',
    icon: 'tab_checklist',
    screen: TodoScreen as RootScreen,
    path: '/checklist',
    auth: true,
    // scopes: [], TODO : add scopes
  },
  tenants: {
    name: 'tenants',
    icon: 'apartment',
    screen: TenantsScreen as RootScreen,
    path: '/tenants',
    auth: true,
    scopes: [AuthScope.LocatairesPermanentsLecture],
  },
  tenantDetail: {
    name: 'tenantDetail',
    icon: 'apartment',
    screen: TenantDetailScreen as unknown as RootScreen,
    path: '/tenant/:tenantId',
    auth: true,
    scopes: [AuthScope.LocatairesPermanentsLecture],
  },
  documents: {
    name: 'documents',
    icon: 'apartment',
    screen: DocumentsScreen as unknown as RootScreen,
    path: '/documents',
    auth: true,
  },
  incident: {
    name: 'incident',
    icon: 'apartment',
    screen: IncidentDetailScreen as unknown as RootScreen,
    path: '/incidentDetail/:incidentId',
    auth: true,
  },
  incidents: {
    name: 'incidents',
    icon: 'apartment',
    screen: IncidentListScreen as unknown as RootScreen,
    path: '/incidents',
    auth: true,
  },
  incidentsWithFilter: {
    name: 'incidentsWithFilter',
    icon: 'apartment',
    screen: FilteredIncidentListScreen as unknown as RootScreen,
    path: '/incidents/list',
    auth: true,
  },
  unaffectedIncidents: {
    name: 'unaffectedIncidents',
    icon: 'apartment',
    screen: UnaffectedIncidentListScreen as unknown as RootScreen,
    path: '/unaffected_incidents',
    auth: true,
    scopes: [AuthScope.DemandesPrestataireAffectation],
  },
  incidentForm: {
    name: 'incidentForm',
    icon: 'apartment',
    screen: IncidentFormScreen as RootScreen,
    path: '/incident/:formStep',
    auth: true,
  },
  login: {
    name: 'login',
    icon: 'apartment',
    screen: LoginScreen as RootScreen,
    path: '/login',
    auth: false,
  },
  loginSso: {
    name: 'loginSso',
    icon: 'apartment',
    screen: LoginSsoCallbackScreen as unknown as RootScreen,
    path: '/login/viparisstore/callback',
    auth: false,
  },
  plan: {
    name: 'plan',
    icon: 'map',
    screen: MapScreen as unknown as RootScreen,
    path: '/plan',
    auth: true,
    scopes: [AuthScope.DemandesPlanLecture],
  },
  incidentExpo: {
    name: 'incidentExpo',
    icon: 'apartment',
    screen: ExpoIncidentDetailScreen as unknown as RootScreen,
    path: '/incidentDetailExpo/:incidentNumber',
    auth: false,
  },
  incidentFormExpo: {
    name: 'incidentFormExpo',
    icon: 'apartment',
    screen: IncidentFormScreen as RootScreen,
    path: '/incident/:formStep',
    auth: false,
  },
  controles: {
    name: 'controles',
    icon: 'tab_quality',
    screen: ControleListScreen as RootScreen,
    path: '/controles',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteLecture, AuthScope.ControleQualitePrestataireLecture],
  },
  controle: {
    name: 'controle',
    icon: 'tab_quality',
    screen: ControleScreen as unknown as RootScreen,
    path: '/controles/:id',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteLecture, AuthScope.ControleQualitePrestataireLecture],
  },
  controleForm: {
    name: 'controleForm',
    icon: 'tab_quality',
    screen: ControleFormScreen as unknown as RootScreen,
    path: '/controles/form/:formStep',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteCreation, AuthScope.ControleQualitePrestataireCreation],
  },
  controleDetail: {
    name: 'controleDetail',
    icon: 'tab_quality',
    screen: ControleDetailScreen as unknown as RootScreen,
    path: '/controles/details/infos',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteLecture, AuthScope.ControleQualitePrestataireLecture],
  },
  controleHistory: {
    name: 'controleHistory',
    icon: 'tab_quality',
    screen: ControleHistoryListScreen as unknown as RootScreen,
    path: '/controles/history/list',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteLecture, AuthScope.ControleQualitePrestataireLecture],
  },
  controleHistoryDetail: {
    name: 'controleHistoryDetail',
    icon: 'tab_quality',
    screen: ControleHistoryDetailScreen as unknown as RootScreen,
    path: '/controles/details/detail',
    auth: true,
    scopes: [AuthScope.ControleQualiteSiteLecture, AuthScope.ControleQualitePrestataireLecture],
  },
  'admin.organizers': {
    name: 'admin.organizers',
    icon: 'settings',
    screen: AdminOrgaListScreen as RootScreen,
    path: '/admin/organizers',
    auth: true,
    scopes: [AuthScope.AdminUtilisateursManifestation, AuthScope.AdminUtilisateursToutesManifestation],
  },
  'admin.providers': {
    name: 'admin.providers',
    icon: 'settings',
    screen: AdminPrestaScreen as RootScreen,
    path: '/admin/providers',
    auth: true,
    scopes: [AuthScope.AdminUtilisateursSociete, AuthScope.AdminUtilisateursToutesSociete],
  },
  'admin.users': {
    name: 'admin.users',
    icon: 'settings',
    screen: UserListScreen as RootScreen,
    path: '/admin/users',
    auth: true,
    scopes: [AuthScope.AdminUtilisateursTous],
  },
  'admin.user': {
    name: 'admin.user',
    icon: 'settings',
    screen: AdminUserScreen as unknown as RootScreen,
    path: '/admin/users/:userId',
    auth: true,
    scopes: [
      AuthScope.AdminUtilisateursTous,
      AuthScope.AdminUtilisateursManifestation,
      AuthScope.AdminUtilisateursToutesManifestation,
      AuthScope.AdminUtilisateursToutesSociete,
      AuthScope.AdminUtilisateursSociete,
    ],
  },
  'admin.manif': {
    name: 'admin.manif',
    icon: 'settings',
    screen: AdminManifScreen as unknown as RootScreen,
    path: '/admin/organizers/:manifestationId',
    auth: true,
    scopes: [AuthScope.AdminUtilisateursManifestation, AuthScope.AdminUtilisateursToutesManifestation],
  },
  'admin.service': {
    name: 'admin.service',
    icon: 'settings',
    screen: AdminServiceScreen as unknown as RootScreen,
    path: '/admin/providers/:prestataireId',
    auth: true,
    scopes: [AuthScope.AdminUtilisateursSociete, AuthScope.AdminUtilisateursToutesSociete],
  },
  'admin.users.form': {
    name: 'admin.users.form',
    icon: 'settings',
    screen: AdminUserFormScreen as RootScreen,
    path: '/admin/users/form/:formStep',
    auth: true,
    scopes: [
      AuthScope.AdminUtilisateursCreationTous,
      AuthScope.AdminUtilisateursCreationPrestataire,
      AuthScope.AdminUtilisateursCreationOrganisateur,
    ],
  },
  'admin.roles': {
    name: 'admin.roles',
    icon: 'settings',
    screen: AdminRoleListScreen as unknown as RootScreen,
    path: '/admin/roles',
    auth: true,
    scopes: [AuthScope.AdminRoleEdition],
  },
  'admin.role': {
    name: 'admin.role',
    icon: 'settings',
    screen: AdminRoleScreen as unknown as RootScreen,
    path: '/admin/roles/:id',
    auth: true,
    scopes: [AuthScope.AdminRoleEdition],
  },
  'admin.roles.form': {
    name: 'admin.roles.form',
    icon: 'settings',
    screen: AdminRoleFormScreen as RootScreen,
    path: '/admin/roles/form/:formStep',
    auth: true,
    scopes: [AuthScope.AdminRoleEdition],
  },
  'admin.jobs': {
    name: 'admin.jobs',
    icon: 'settings',
    screen: AdminJobsScreen as RootScreen,
    path: '/admin/jobs',
    auth: true,
    scopes: [AuthScope.AdminTacheLancementManuel],
  },
  'admin.plans': {
    name: 'admin.plans',
    icon: 'settings',
    screen: AdminPlanListScreen as unknown as RootScreen,
    path: '/admin/plans',
    auth: true,
    scopes: [AuthScope.AdminPlanCreation],
  },
  'admin.plan': {
    name: 'admin.plan',
    icon: 'settings',
    screen: AdminPlanScreen as unknown as RootScreen,
    path: '/admin/plans/:spaceId',
    auth: true,
    scopes: [AuthScope.AdminPlanCreation],
  },
  'admin.plans.form': {
    name: 'admin.plans.form',
    icon: 'settings',
    screen: AdminPlanFormScreen as RootScreen,
    path: '/admin/plans/form/:formStep',
    auth: true,
    scopes: [AuthScope.AdminPlanCreation],
  },
  resetPassword: {
    name: 'resetPassword',
    icon: 'apartment',
    screen: ResetPassword as unknown as RootScreen,
    path: '/resetPassword',
    auth: false,
  },
  resetPasswordLogged: {
    name: 'resetPasswordLogged',
    icon: 'apartment',
    screen: ResetPassword as unknown as RootScreen,
    path: '/resetPassword',
    auth: true,
  },

  // Dev only
  storybook: {
    name: 'storybook',
    icon: 'painting',
    screen: StorybookScreen as RootScreen,
    path: '/storybook',
    auth: false,
  },
}

export default screens
